import React from 'react';

/** A single "Wrapped" stat tile: emoji, bold value, label. */
export default function StatCard({ emoji, value, label, accent = '#c49b63' }) {
  return (
    <div
      style={{
        flex: '1 1 150px', minWidth: 140, padding: '14px 16px', textAlign: 'center',
        background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 14,
      }}
    >
      <div style={{ fontSize: 24, marginBottom: 4, lineHeight: 1 }}>{emoji}</div>
      <div style={{ fontSize: 24, fontWeight: 800, color: accent, lineHeight: 1.1 }}>{value}</div>
      <div style={{ color: 'var(--tp-muted, #9aa4b2)', fontSize: 12.5, marginTop: 4 }}>{label}</div>
    </div>
  );
}
